<template>
  <div class="config row">
    <div class="col-xs-12 mt-sm-1">
      <div :class="computedClassHeader">Configuração / Resets</div>
      <b-card-group deck :class="computedClass">
        <b-card>
          <header slot="header" align="center">
            <h4>CIR</h4>
          </header>
          <p class="card-text center-xs text-lg-left">
            Ao reiniciar o sistema,
            <strong>a irrigação será interrompida</strong> por um curto período
            de tempo. <strong>Todos os usuários serão deslogados.</strong>
          </p>
          <b-button slot="footer" block variant="3v3" @click="rebootCir()"
            >REINICIAR
          </b-button>
          <b-button slot="footer" block variant="3v3" @click="haltCir()"
            >DESLIGAR
          </b-button>
        </b-card>
        <b-card>
          <header slot="header" align="center">
            <h4>Servidor</h4>
          </header>
          <p class="card-text center-xs" style="padding: 30px 0">
            Ao reiniciar o sistema,
            <strong>todos os usuários serão deslogados.</strong>
          </p>
          <b-button slot="footer" block variant="3v3" @click="restartServer()"
            >REINICIAR
          </b-button>
        </b-card>
      </b-card-group>
    </div>
    <b-modal
      ref="dialogCMD"
      centered
      hide-header
      @ok="submitAction"
      ok-variant="danger"
      :ok-title="msg && msg.split(' ')[0]"
      cancel-title="Cancelar"
    >
      <h4>{{ msg }}</h4>
    </b-modal>
  </div>
</template>

<script>
import { cmd } from "@/api";

export default {
  name: "reset",
  props: {
    mobile: Boolean,
  },
  data() {
    return {
      msg: "",
      action: "",
    };
  },
  computed: {
    computedClass() {
      if (this.mobile) {
        return "mobile-header pt-5";
      }
      return "desktop-header mt-4";
    },
    computedClassHeader() {
      if (this.mobile) {
        return "page-title config-title-mobile col-xs-12  mt-0";
      }
      return "page-title config-title col-xs-12  mt-0";
    },
  },
  methods: {
    rebootCir() {
      this.msg = "Reiniciar CIR?";
      this.action = "/home/pi/sirv4/scripts/safe_reboot.sh";
      this.$refs.dialogCMD.show();
    },
    haltCir() {
      this.msg = "Desligar CIR?";
      this.action = "sudo halt";
      this.$refs.dialogCMD.show();
    },
    restartServer() {
      this.msg = "Reiniciar sistema?";
      this.action = "pm2 restart all";
      this.$refs.dialogCMD.show();
    },
    submitAction() {
      let data = {
        CMD: this.action,
      };
      cmd
        .exec(data)
        .then((ret) => {
          let msg = "";
          if (ret.status) msg = "Sucesso ao executar comando.";
          else msg = "Erro ao executar comando.";
          alert(msg, ret.alert);
        })
        .catch((err) => {
          alert("Ocorreu um erro. Recarregue a página.");
        });
    },
  },
};
</script>

<style scoped>
/* .mobile-header{
  margin-top: 40px;
} */
.config-title {
  max-height: 1.1em;
  padding: 0 0 4px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.config-title-mobile {
  top: 36px;
}
@media screen and (max-width: 767px) {
  .card-text {
    font-size: 0.88em;
  }
}
.card-text > div > p {
  color: var(--text-gray-primary);
}
</style>
